import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import moment from 'moment'
import HandleMapViewerModal from './HandleMapViewerModal'

type MapViewer = { _id: String, name: String, email: String, zip: String, password: String, lastActive: String }

type Props = {
  mapViewer: MapViewer,
  updateMapViewer: Function,
  removeMapViewer: Function,
}

const MapViewerRow = ({ mapViewer, updateMapViewer, removeMapViewer }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <tr>
      <td>
        <Button className="save-settings-btn" style={{ width: '100px' }} type="submit" onClick={() => setIsModalOpen(!isModalOpen)}>
          Hantera
        </Button>
        <HandleMapViewerModal isModalOpen={isModalOpen} closeModal={() => setIsModalOpen(false)} mapViewer={mapViewer} updateMapViewer={updateMapViewer} removeMapViewer={removeMapViewer} />
      </td>
      <td>{mapViewer.name}</td>
      <td>{mapViewer.email}</td>
      <td>
        {mapViewer.lastActive
          ? moment(mapViewer.lastActive)
              .locale('sv')
              .format('llll')
          : ''}
      </td>
      <td>{mapViewer.zip}</td>
    </tr>
  )
}

export default MapViewerRow
